import './index.less';
import MultiCamera from './MultiCamera';

MultiCamera.install = function(Vue) {
  Vue.component(MultiCamera.name, MultiCamera);
};

export default MultiCamera;
